/* Dish photos. A dish can have a Main Dish photo and a Meal Box photo (Dashboard → dish →
 * Photos). Meal Sets and boxed-meal packages show the Meal Box one; dish-only portions and
 * main-dish / Small Table packages show the Main Dish one. A type with no photo borrows the
 * other, so a dish with a single photo shows it everywhere. Leave `kind` out for the photo
 * of the portion the dish opens on. */

// The API returns /media/... paths; media is only served from the API host (the SPA host
// answers those paths with index.html). Same rule the rest of the storefront follows.
export function mediaUrl(path) {
  if (!path) return '';
  return /^https?:\/\//.test(path) ? path : `https://api.chds.com.au${path}`;
}

export function photoKindForPortion(p) {
  if (!p) return undefined;
  return String(p.portion_code || '').toLowerCase() === 'medium' || /meal.?set/i.test(p.portion_name || '') ? 'box' : 'main';
}

export function photoKindForPackage(pkg) {
  if (!pkg) return undefined;
  return pkg.kind === 'boxed' ? 'box' : 'main';
}

/* The dish page and weekly cards open on the first listed portion; the classic menu popup
 * (and the cards that lead to it) on the lightest one. */
export function defaultPhotoKind(d, { lightestFirst = false } = {}) {
  let ps = ((d && d.portion) || []).filter((p) => p.price !== null);
  if (lightestFirst) ps = [...ps].sort((a, b) => (parseFloat(a.portion_weight) || 0) - (parseFloat(b.portion_weight) || 0));
  return photoKindForPortion(ps[0]) || 'main';
}

export function dishPhoto(d, kind) {
  const imgs = (d && d.item_images) || [];
  const k = kind || defaultPhotoKind(d);
  return imgs.find((x) => x.kind === k) || imgs.find((x) => x.kind) || imgs.find((x) => x.is_main) || imgs[0] || null;
}
export function dishImage(d, kind) {
  const i = dishPhoto(d, kind);
  return i ? mediaUrl(i.image) : '';
}
export function dishFocal(d, kind) {
  const i = dishPhoto(d, kind);
  return i && i.focal_x != null ? `${i.focal_x}% ${i.focal_y}%` : 'center';
}
export function dishFocalPoint(d, kind) {
  const i = dishPhoto(d, kind);
  return i && i.focal_x != null ? { x: i.focal_x, y: i.focal_y } : null;
}
